export default __webpack_public_path__ + "static/media/nodewebkit.96e2fdf4.svg";